export const SITE = {
  name: "Quivio",
  url: "https://quivio.com",
  defaultTitle: "Custom Software Development and Software Consulting",
  defaultDescription:
    "Quivio is a custom software development and consulting studio in Ontario, Canada. We design and build tailored web, mobile, and cloud products for growing teams.",
  defaultImage: "https://quivio.com/logo512.png",
};

export const getAbsoluteUrl = (path = "/") => {
  if (!path) return SITE.url;
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${SITE.url}${normalized}`;
};

export const buildTitle = (title) => {
  if (!title) return `${SITE.defaultTitle} | ${SITE.name}`;
  return `${title} | ${SITE.name}`;
};

export const getOrganizationSchema = (description) => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": `${SITE.url}/#organization`,
  "name": SITE.name,
  "url": SITE.url,
  "logo": SITE.defaultImage,
  "description": description || SITE.defaultDescription,
});

export const getWebsiteSchema = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${SITE.url}/#website`,
  "url": SITE.url,
  "name": SITE.name,
  "publisher": { "@id": `${SITE.url}/#organization` },
});

export const getProfessionalServiceSchema = ({ description, serviceTypes } = {}) => ({
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  "@id": `${SITE.url}/#professional-service`,
  "name": `${SITE.name} Software Consulting`,
  "url": SITE.url,
  "image": SITE.defaultImage,
  "description": description || SITE.defaultDescription,
  "areaServed": "Ontario, Canada",
  "serviceType": serviceTypes && serviceTypes.length
    ? serviceTypes
    : [
        "Custom software development",
        "Software consulting",
        "Tailored software",
        "Product design",
      ],
  "provider": { "@id": `${SITE.url}/#organization` },
});

export const getServiceListSchema = (services = []) => ({
  "@context": "https://schema.org",
  "@type": "ItemList",
  "name": "Software development services",
  "itemListElement": services
    .filter((service) => service && service.title)
    .map((service, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "item": {
        "@type": "Service",
        "name": service.title,
        "serviceType": service.title,
        "description": service.description,
        "provider": {
          "@type": "Organization",
          "name": SITE.name,
          "url": SITE.url,
        },
      },
    })),
});

export const getBlogPostingSchema = ({ title, description, date, url }) => ({
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  "headline": title,
  "description": description,
  "datePublished": date,
  "dateModified": date,
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": url,
  },
  "author": {
    "@type": "Organization",
    "name": SITE.name,
    "url": SITE.url,
    "logo": SITE.defaultImage,
  },
  "publisher": {
    "@type": "Organization",
    "name": SITE.name,
    "url": SITE.url,
    "logo": SITE.defaultImage,
  },
  "image": [SITE.defaultImage],
});
